import React from 'react';
import { ObjectCardTile, ObjectCardTone } from '../../components/layout/ObjectCard';

// Header of one panel widget: icon tile, title, and one link or note on the
// right (DESIGN.md „Direction since 2026-10-19”: icon tiles, one line).
const DashboardWidgetHeader: React.FC<{
  title: string;
  icon: React.ReactNode;
  tone: ObjectCardTone;
  aside?: React.ReactNode;
}> = ({ title, icon, tone, aside }) => (
  <div className="dashboard-section__header">
    <ObjectCardTile tone={tone} size="sm">{icon}</ObjectCardTile>
    <h4 className="dashboard-section__title" title={title}>{title}</h4>
    {aside && <div className="dashboard-section__aside">{aside}</div>}
  </div>
);

export default DashboardWidgetHeader;
